import { render, staticRenderFns } from "./DlgGroupSelector.vue?vue&type=template&id=3473cdec&scoped=true"
import script from "./DlgGroupSelector.vue?vue&type=script&lang=ts"
export * from "./DlgGroupSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3473cdec",
  null
  
)

export default component.exports